// SETTINGS V2 — Pricing (Ceny a predvolby) pure-data module (SETTINGS_V2_SP7 §3/§5.1).
// Enum const maps ported VERBATIM from the legacy SettingsPricing.tsx (lines 27-29)
// + the three select-option builders. NO state, NO JSX, NO i18n import — the caller
// passes its `translate` fn so the option labels stay localized.
//
// SENTINELS ARE BINDING AND DISTINCT (SP7 §2): Warranty Custom = 5, Payment
// Custom = 5, Validity Custom = 6. Do NOT unify these maps.
import type { FormSelectOption } from "../../../../shared/components/redesign/forms/FormSelect";

// Enum values matching backend (ported verbatim from legacy lines 27-29).
export const WarrantyPeriodCode = {
  ThirtyDays: 1,
  NinetyDays: 2,
  SixMonths: 3,
  OneYear: 4,
  Custom: 5,
};
export const PaymentTermsCode = {
  PaymentOnCompletion: 1,
  Net30Days: 2,
  FiftyAdvanceFiftyCompletion: 3,
  Net60Days: 4,
  Custom: 5,
};
export const ValidityPeriodCode = {
  ThreeDays: 1,
  FiveDays: 2,
  SevenDays: 3,
  FourteenDays: 4,
  ThirtyDays: 5,
  Custom: 6,
};

type TranslateFn = (key: string) => string;

// Sentinel 0 → label "--" (maps to null in the payload); then the enum options
// with their EXISTING i18n keys (SP7 §5.1).
export const buildWarrantyOptions = (t: TranslateFn): FormSelectOption[] => [
  { value: 0, label: "--" },
  { value: WarrantyPeriodCode.ThirtyDays, label: t("settings:pricing.warranty30days") },
  { value: WarrantyPeriodCode.NinetyDays, label: t("settings:pricing.warranty90days") },
  { value: WarrantyPeriodCode.SixMonths, label: t("settings:pricing.warranty6months") },
  { value: WarrantyPeriodCode.OneYear, label: t("settings:pricing.warranty1year") },
  { value: WarrantyPeriodCode.Custom, label: t("settings:pricing.warrantyCustom") },
];

export const buildPaymentOptions = (t: TranslateFn): FormSelectOption[] => [
  { value: 0, label: "--" },
  { value: PaymentTermsCode.PaymentOnCompletion, label: t("settings:pricing.paymentOnCompletion") },
  { value: PaymentTermsCode.Net30Days, label: t("settings:pricing.paymentNet30") },
  { value: PaymentTermsCode.FiftyAdvanceFiftyCompletion, label: t("settings:pricing.payment5050") },
  { value: PaymentTermsCode.Net60Days, label: t("settings:pricing.paymentNet60") },
  { value: PaymentTermsCode.Custom, label: t("settings:pricing.paymentCustom") },
];

export const buildValidityOptions = (t: TranslateFn): FormSelectOption[] => [
  { value: 0, label: "--" },
  { value: ValidityPeriodCode.ThreeDays, label: t("settings:pricing.validity3days") },
  { value: ValidityPeriodCode.FiveDays, label: t("settings:pricing.validity5days") },
  { value: ValidityPeriodCode.SevenDays, label: t("settings:pricing.validity7days") },
  { value: ValidityPeriodCode.FourteenDays, label: t("settings:pricing.validity14days") },
  { value: ValidityPeriodCode.ThirtyDays, label: t("settings:pricing.validity30days") },
  { value: ValidityPeriodCode.Custom, label: t("settings:pricing.validityCustom") },
];
